export const VIDEO_ASSETS = {
  "agentica/rental-tracker": {
    playbackId: "hu9mhkLztzthUSEdcfB97cQAQoncQ2kj02RgeA1x01bAY",
  },
  "agentica/travel-hub": {
    playbackId: "yszHNQ9ubibMLBjG02H3MdrZo5yAwpRWuJRUYnkSM88g",
  },
  "agentica/sales-finder": {
    playbackId: "2CZOcDO3UaTbP01T62VvCOL2Uzsh2lpYo94OMXH8Ju02A",
  },
  "agentica/feature-01": {
    playbackId: "uhj02lQjL56nhtdG6JyAu78A02HAOIZNVOlBmNW4N0097A",
  },
  "agentica/feature-02": {
    playbackId: "2KhHvcGPebBwjxTu02azTGVWlMPJfWTTLVqs4FXAy5Ig",
  },
  "agentica/feature-03": {
    playbackId: "OzcHH7MyNrsjNeAjN7CASTIxQ01bsbWgpOz1McCkO00Yg",
  },
  "agentica/feature-04": {
    playbackId: "JBRQAAWcMAi029Ws2TKMBcLjwyLYWvx9YRGSEZ1Ow3Uo",
  },
  "agentica-sdk/arc3": {
    playbackId: "102Qg2Xlu00FAUrMjWf12S5mmAhK2nlfd22jWdk01iI9qE",
  },
  "agentica-sdk/runtime-as-context": {
    playbackId: "P8kD4Q8WU01aefQA9BS2602uBmvU87F800WNBWCHJhhOvg",
  },
  "agentica-sdk/algobot": {
    playbackId: "7rXzjnIizbtg3rhtvmEMacSnFQf9JODgtT3V9sxKK4w",
  },
  "introducing-agentica/rental-tracker": {
    playbackId: "hu9mhkLztzthUSEdcfB97cQAQoncQ2kj02RgeA1x01bAY",
  },
  "arc-agi-3/tu93": {
    playbackId: "sVNT6Ep4nz00nvoyUuvStR01Wi22YSjTXBNGvPeRwjUv4",
  },
  "arc-agi-3/sb26": {
    playbackId: "palFTQZ7rDmN6cS9k53YlRissI800LC0077yzD029eBQhA",
  },
  "arc-agi-3/lp85": {
    playbackId: "qf14iIW8F8oido4gmGxim8yQD5RC02FtSF4xT01NQOAEY",
  },
  "arc-agi-3/ft09": {
    playbackId: "w2sOVnafHlJGF00ILng9eGYq01yga7pEgX5fASHb8ts3o",
  },
  "arc-agi-3/cn04": {
    playbackId: "01b1TIx00ECcVv02jHPnJSIfJt00JRf4ELpnOgQnagvdeLE",
  },
  "arc-agi-3/cd82": {
    playbackId: "MUaSxY73urLPURo01CUtQJVSS02fyjQHuJeW3TKGontp00",
  },
  "arc-agi-3/ar25": {
    playbackId: "PhmAUS8cgD01ygUvKcK8ZGd8w7EtlqMJqLyoz00jlHS6Y",
  },
} as const;

export type VideoAssetKey = keyof typeof VIDEO_ASSETS;

/** Get a Mux thumbnail URL for a given asset key */
export function getMuxThumbnail(
  key: VideoAssetKey,
  opts?: { width?: number; height?: number; time?: number }
): string {
  const { playbackId } = VIDEO_ASSETS[key];
  const params = new URLSearchParams();
  if (opts?.width) params.set("width", String(opts.width));
  if (opts?.height) params.set("height", String(opts.height));
  if (opts?.time !== undefined) params.set("time", String(opts.time));
  const qs = params.toString();
  return `https://image.mux.com/${playbackId}/thumbnail.webp${qs ? `?${qs}` : ""}`;
}

/** Map a local video path (e.g. "/videos/agentica/rental-tracker.mp4") to a VideoAssetKey, or undefined */
export function pathToMuxKey(
  path: string | undefined
): VideoAssetKey | undefined {
  if (!path) return undefined;
  // Strip leading /videos/ and trailing .mp4
  const match = path.match(/^\/videos\/(.+)\.mp4$/);
  if (!match) return undefined;
  const key = match[1] as VideoAssetKey;
  return key in VIDEO_ASSETS ? key : undefined;
}
